import { Update } from '@/assets/global/enums/endpoints/UpdateEnum'
import { CommitteeEnum } from '@/assets/global/enums/endpoints/CommitteeEnum'
import { Itineraries } from '@/assets/global/enums/endpoints/ItinerariesEnum'

interface Ids {
  updates?: string
  version?: string
  committee?: string
  course?: string
  step?: string
}

export const RoutesUpdatesObject = [
  {
    regex: /^\/itineraries\/updates\/?$/,
    title: 'Atualizações',
    children: [
      {
        regex: /^\/[\d+]+\/?$/,
        title: async (ids: Ids) => {
          const areaId = Number(ids.updates)
          const versionId = ids.version

          const { data: areaData } =
            areaId > 0
              ? ((await useApiModified([
                  createUrl(
                    Update.AREA_ID.replace('{areaId}', String(areaId)),
                    {
                      query: { versionId },
                    },
                  ),
                ])) as { data: any; response: any })
              : { data: undefined }

          return areaData?.value?.data?.areaVersion?.area?.name ?? ''
        },
        breadcrumb: true,
      },
      {
        regex: /^\/committee\/[\d+]+\/?$/,
        title: async (ids: Ids) => {
          const committeeId = Number(ids.committee)

          const { data: committeeData } =
            committeeId > 0
              ? ((await useApiModified([
                  createUrl(
                    CommitteeEnum.COMMITTEE_ID.replace(
                      '{id}',
                      String(committeeId),
                    ),
                  ),
                ])) as { data: any; response: any })
              : { data: undefined }

          const segment = committeeData?.value?.data?.segment
          return segment ? `Comitê - ${segment}` : 'Comitê'
        },
        breadcrumb: true,
        children: [
          {
            regex: /^\/course\/\d+(?:\?.*)?$/,
            title: async (ids: Ids) => {
              const courseVersionId = Number(ids.course)

              const { data: courseData } =
                courseVersionId > 0
                  ? ((await useApiModified([
                      createUrl(
                        Itineraries.COURSE_VERSION_ID.replace(
                          '{courseVersionId}',
                          String(courseVersionId),
                        ),
                      ),
                    ])) as { data: any; response: any })
                  : { data: undefined }

              const courseName = courseData?.value?.data?.name ?? ''
              const step = ids.step === '9'
                ? ' | Plano de Curso'
                : ids.step
                  ? ` | Etapa ${ids.step}`
                  : ''

              return `${courseName}${step}`
            },
            breadcrumb: true,
          },
        ],
      },
    ],
  },
]

export const RoutesUpdatesComponents = [
  {
    path: '/itineraries/updates/committee/:committeeId/course/:courseVersionId',
    name: 'committee-course',
    component: () => import('@/pages/itineraries/updates/committee/course.vue'),
  },
]
